/* eslint-disable react/require-default-props */
import React from 'react';
import classNames from 'classnames';
import getFullNameWithTitle from '@medflex/utils/getFullNameWithTitle';
import format from 'date-fns/format';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

const RepresentedPerson = ({ userDetails, className = '' }) => {
  const { t } = useTranslation('components');
  const cn = classNames(className);

  const { dateOfBirth } = userDetails;
  const dateOfBirthString = dateOfBirth && `* ${format(userDetails.dateOfBirth, 'DD.MM.YYYY')}`;

  return (
    <div className={cn}>
      <div className="text-sm font-semibold leading-5 text-slate-600">
        {t('RepresentedPerson.title')}
      </div>
      <div className="flex flex-col">
        <span className="whitespace-pre-line break-words">{getFullNameWithTitle(userDetails)}</span>
        {dateOfBirth && (
          <span className="whitespace-pre-line break-words">{dateOfBirthString}</span>
        )}
      </div>
    </div>
  );
};

RepresentedPerson.propTypes = {
  userDetails: PropTypes.shape({
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    dateOfBirth: PropTypes.string,
    gender: PropTypes.string,
  }).isRequired,
  className: PropTypes.string,
};

export default RepresentedPerson;
